/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

 import { Navigate, useNavigate } from 'react-router-dom';
 import DashboardLayout from '../layout/DashboardLayout';
 import CurrentRole from '../widgets/CurrentRole';
 import RequestARole from '../widgets/RequestARole';
 import RequestStatus from '../widgets/RequestStatus';
 import { DashBoardWidget } from './widget';
 import prattImage from "../../images/pratt_image.png";
 import dashboardStyle from '../../styles/Dashboard.module.css';
 import { useAppSelector } from '../../redux/hooks';
 import { isLoggedInSelector } from '../../redux/loginSlice';
 
 const MainDashboard = () => {
   const navigate = useNavigate();
 
   const { user } = useAppSelector(isLoggedInSelector);
 
   const getUserName = () => {
     if (!!user){
       return <>{user.given_name}</>
     }
   }
 
   const getsupportmail = () => {
     return (<div>Need assistance? Contact our support team at <a style={{textDecoration: "none"}} dangerouslySetInnerHTML={{__html: 'portalidentity@prattwhitney.com'}} /></div>)
   }
 
   return (
     <>
     
      <DashboardLayout
       widget1={ <div className={dashboardStyle.welcomeImageWidget}>
       <img src={prattImage}></img> 
         <div className={dashboardStyle.text_on_image}>
                <div className={dashboardStyle.welome_Message}>Welcome, {getUserName()} !</div>
                <div className={dashboardStyle.Welcome_portal}>Portal Registration </div>
             </div>
       </div>}
       widget2={ <DashBoardWidget header="Request New Role" icon="send"
      description='Select from available
       resources and roles to request application access.'
       footer={{title:'Request a New Role',onCLick:()=>{
        navigate('/roleRequest?tab=requestRoles')
       }}}
       iconsize = "medium"
       footerStyle={dashboardStyle.footerContainer}
     />}
       widget3={
         <DashBoardWidget header="My Resources" icon="sync"
         description='View and manage the status of your current resouce and role access.'
          footer={{title:'View Request Status',onCLick:()=>{
           navigate('/roleRequest?tab=myResources')
          }}}
          footerStyle={dashboardStyle.footerContainer}
          iconsize = "medium"
        />
       }
       widget4 ={
         <DashBoardWidget header="All resources" icon="folder-closed"
         description='View a summary of current accessible resources and applications.'
          footer={{title:'Review Resources',onCLick:()=>{
           navigate('/roleRequest?tab=resourceDescriptions')
          }}}
          iconsize = "medium"
          footerStyle={dashboardStyle.footerContainer}
        />
       }
       widget5 = {
         <DashBoardWidget header="Support" icon="support"     
         description={getsupportmail()} 
         iconsize = "medium"    
         // footer={undefined}
        />
       }
     >
     </DashboardLayout>
     </>
 
   );
 };
 
 export default MainDashboard;
 